import { PayloadAction, AnyAction } from "@reduxjs/toolkit";
import { ReduxHelper } from "helpers";
import { EAlertType } from "helpers/alertHelper";
import { IBaseReducerState } from "helpers/reduxHelpers";
import { isEmpty } from "lodash";
import { IApiResponse } from "model/Common/IApiResponse";
import { AlertActions, IdentityActions } from "redux/actions";
interface IAlertState extends IBaseReducerState {
  alert: {
    show?: boolean;
    message?: string;
    type?: EAlertType;
  };
}

const initialState: IAlertState = {
  alert: {
    show: false,
  },
  action: AlertActions.prefix,
  prefix: AlertActions.prefix,
};

const showAlert = (
  state: IAlertState,
  action: PayloadAction<{ message: string; type: EAlertType }>
) =>
  ReduxHelper.handleReducerBuilder(state, action, () => {
    state.alert = {
      ...action.payload,
      show: true,
    };
  });
const closeAlert = (state: IAlertState, action: PayloadAction<any>) =>
  ReduxHelper.handleReducerBuilder(state, action, () => {
    state.alert = {
      show: false,
      message: undefined,
      type: undefined,
    };
  });
const AppReducer = ReduxHelper.createHandleReducer(initialState, (builder) => {
  builder
    .addCase(AlertActions.showAlert.request, showAlert)
    .addCase(AlertActions.closeAlert.request, closeAlert)
    .addMatcher(
      (action) =>
        action.type.includes("_FAILED") &&
        !action.type.includes("IMPORT") &&
        !action.type.includes(IdentityActions.pingAuthenticate.failedName),
      (state: IAlertState, action: PayloadAction<IApiResponse<any>>) => {
        state.alert = {
          message: !isEmpty(action.payload.message)
            ? action.payload.message[0].Text
            : !isEmpty(action.payload.errors)
            ? action.payload.errors
            : "Unknown error",
          type: EAlertType.ERROR,
          show: true,
        };
      }
    );
});

export default AppReducer;
